// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const progressNotesAPI = createApi({
  reducerPath: "progressNotesAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["notes"],
  endpoints: (builder) => ({
    getProgressNotesList: builder.query<any, GoalsAndActionPlansArgTypes>({
      query: ({ affiliateCode, aboNumber, year }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/notes/year/${year}`,
        method: "GET",
      }),
      providesTags: ["notes"],
    }),

    createProgressNotes: builder.mutation<any, createNotesArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/note/create`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["notes"],
    }),
    editProgressNotes: builder.mutation<any, editeNotesArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/note/update`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["notes"],
    }),
    deleteProgressNote: builder.mutation<any, deleteNotesArgTypes>({
      query: ({ id }) => ({
        url: `/am/abo/note/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["notes"],
    }),
    getUsersListByNativeIDs: builder.query<any, getUsersByNativeIDArgTypes>({
      query: ({ nativeIDs }) => ({
        url: `/auth/users/native`,
        method: "GET",
        params: { "native": nativeIDs }
      }),
      providesTags: ["notes"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProgressNotesListQuery,
  useCreateProgressNotesMutation,
  useEditProgressNotesMutation,
  useDeleteProgressNoteMutation,
  useGetUsersListByNativeIDsQuery
} = progressNotesAPI;
